export default "__VITE_ASSET__D1y6tzLS__"